import { ChangeEvent, ReactElement } from "react";

import { Asset, UpdateAssetInput } from "../../generated/gql/graphql";

import AssetDetails from "./asset-details";
import Comments from "./comments";

type Props = {
  asset: Asset;
  isEdit: boolean;
  update: UpdateAssetInput | undefined;

  onChange(event: ChangeEvent<HTMLInputElement>): void;
};

export default function AssetPropertyDetails(props: Props): ReactElement {
  const { asset, isEdit, update, onChange } = props;

  return (
    <div
      // className={`${messageNavigation ? "w-3/5" : "w-1/2"} ml-[50px]`}
      className="w-1/2 ml-[50px]"
    >
      <div className="flex">
        <AssetDetails
          isEdit={isEdit}
          asset={asset}
          update={update}
          onChange={onChange}
        />
        <Comments assetId={asset.id || ""} />
      </div>
    </div>
  );
}
